"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Video = void 0;
var React = __importStar(require("react"));
var video_context_1 = require("../context/video-context");
var classnames_1 = __importDefault(require("classnames"));
var use_metadata_track_list_1 = require("../hooks/use-metadata-track-list");
var selectors_1 = require("../selectors");
var react_1 = require("@xstate/react");
/**
 * React component wrapper for the HTMLVideoElement that supplies an element
 * reference that is registered with the videoService xstate machine.
 *
 * @param children
 * @param loop
 * @param poster
 * @param preload
 * @param src
 * @param autoPlay
 * @param playsInline
 * @param muted
 * @param crossOrigin
 * @param id
 * @param className
 * @constructor
 */
var Video = function (_a) {
    var children = _a.children, _b = _a.loop, loop = _b === void 0 ? false : _b, poster = _a.poster, _c = _a.preload, preload = _c === void 0 ? 'auto' : _c, src = _a.src, _d = _a.autoPlay, autoPlay = _d === void 0 ? false : _d, _e = _a.playsInline, playsInline = _e === void 0 ? false : _e, _f = _a.muted, muted = _f === void 0 ? false : _f, _g = _a.crossOrigin, crossOrigin = _g === void 0 ? 'anonymous' : _g, id = _a.id, className = _a.className;
    //if you type this to an HTMLVideoElement it becomes read only
    //and below we need to manually assign it so we can dispatch
    //to the videoService and update our state machine context
    var videoElemRef = React.useRef(null);
    var videoService = (0, video_context_1.useVideo)();
    var paused = (0, react_1.useSelector)(videoService, selectors_1.selectIsPaused);
    (0, use_metadata_track_list_1.useMetadataTrackList)();
    React.useEffect(function () {
        videoService.send({ type: 'REGISTER', videoRef: videoElemRef });
        // sometimes the event handlers aren't registered before the
        // `canPlay` event is fired (caching, for instance) so we want
        // to check and see if it's ready as soon as we get a ref to
        // the HTMLVideoElement and "manually" fire an event
        if (videoElemRef.current && videoElemRef.current.readyState > 3) {
            videoService.send('LOADED');
        }
    }, [videoElemRef.current]);
    return (React.createElement("video", { className: (0, classnames_1["default"])(["cueplayer-react-video", className]), id: id, crossOrigin: crossOrigin, ref: videoElemRef, muted: muted, preload: preload, loop: loop, playsInline: playsInline, autoPlay: autoPlay, poster: poster, src: src, onError: function () {
            console.error('video player had an error');
        }, onCanPlay: function (_event) {
            videoService.send('LOADED');
        }, onCanPlayThrough: function (_event) {
            videoService.send('LOADED');
        }, onTimeUpdate: function () {
            videoService.send('TIMING');
        }, onWaiting: function () {
            videoService.send('WAITING');
        }, onPlaying: function () {
            videoService.send('DONE_WAITING');
        }, onEnded: function () {
            videoService.send('END');
        }, tabIndex: -1 }, children));
};
exports.Video = Video;
